import { useRouterState, type AnyRouter } from '@tanstack/react-router'

import { SessionSplash } from '@/features/auth/components/session-splash'

export function InitialSessionSplash({ router }: { router: AnyRouter }) {
  const resolved = useRouterState({
    router,
    select: (state) => state.resolvedLocation !== undefined,
  })

  return resolved ? null : <SessionSplash />
}
